import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
html,
body {
  height: 100%;
  width: 100%;
}

body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

#root {
  min-height: 100%;
  min-width: 100%;
}

p,
label {
  font-family: Georgia, Times, 'Times New Roman', serif;
  line-height: 1.5em;
}

input, select {
  font-family: inherit;
  font-size: inherit;
}

.mainCenter {
  display: flex;
  justify-content: center;
  padding: 20px 30px;
}

.adept_primary_btn, 
.adept_primary_btn:hover, 
.adept_primary_btn:focus, 
.adept_primary_btn:focus-visible {
  border-radius: 10px;
  border: 1px solid #b92353;
  background-color: #b92353;
  color: #ffffff;
  min-height: 4vh;
  margin-top: 10px;
  cursor: pointer;
}

.ant-spin-dot-item {
  background-color: white !important;
}

.light {
  background-color: #EEEEEE;
  color: black;
}

.dark {
  background-color: #0e1218;
  color: #eeeeee;
}

.ant-drawer-title {
  color: unset !important;
}

p {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.MuiTablePagination-selectIcon {
  color: unset !important;;
}

.form-section {
  border-bottom: 1px solid #e7e7e7;
  display: grid;
  grid-gap: 16px;
  align-items: center;
  grid-template-columns: minmax(30px, 60px) minmax(100px, 1fr) minmax(100px, 1fr) minmax(100px, 1fr) minmax(200px, 1fr);
  padding: 30px 15px;
  background-color: #fff;
  position: relative;
}


div[class*="switch"] input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  margin-inline: 10px;
  margin-left: 50px;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  height: 26px;
  width: 50px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 0px;
  bottom: 0px;
  background-color: white;
  border: 1px solid grey;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: rgba(185, 35, 83, 0.55);
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(32px);
  -ms-transform: translateX(32px);
  transform: translateX(32px);
  background-color: #b92353;
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

@media (max-width: 600px) {
  .mainCenter {
    padding: 15px;
  }
}`;
